import { Carousel } from "antd";
import { Link } from "react-router-dom";

import slide1 from "../../../assets/landing1.jpg";
import slide2 from "../../../assets/landing2.jpg";
import slide3 from "../../../assets/landing3.jpg";

const slides = [
  {
    image: slide1,
    subtitle: "Welcome to",
    title: "EELLA CAFE",
    desc: "Fish is one of the most wholesome foods that man can eat. In fact, people have been eating fish throughout human history.",
    primaryBtn: "Book a Table",
    primaryLink: "/contact",
    secondaryBtn: "View Menus",
    secondaryLink: "/menu",
  },
  {
    image: slide2,
    subtitle: "Explore",
    title: "TASTY MENU DISHES",
    desc: "Discover our carefully crafted menu made with fresh ingredients and love.",
    primaryBtn: "View Menu Items",
    primaryLink: "/menu",
  },
  {
    image: slide3,
    subtitle: "Join to",
    title: "SPECIAL EVENTS",
    desc: "Celebrate your moments with us in a cozy and elegant atmosphere.",
    primaryBtn: "Learn More",
    primaryLink: "/about",
  },
];

const LandingPage = () => {
  return (
    <Carousel
      autoplay
      autoplaySpeed={5000}
      speed={1200}
      effect="fade"
      pauseOnHover={false}
    >
      {slides.map((slide, index) => (
        <div key={index}>
          <div
            className="relative h-[560px] md:h-[100vh] bg-center bg-cover"
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="absolute inset-0 bg-black/50" />

            {/* Content */}
            <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 text-primary-50 max-w-3xl mx-auto">
              <p className="text-primary-100 font-italianno text-4xl mb-2">
                {slide.subtitle}
              </p>

              <h1 className="text-3xl md:text-5xl font-sans font-bold tracking-wide mb-4">
                {slide.title}
              </h1>

              <div className="w-12 h-[2px] bg-background-soft mb-4" />

              <p className="text-sm md:text-base opacity-90 mb-8">
                {slide.desc}
              </p>

              {/* Buttons */}
              <div className="flex gap-4 flex-wrap justify-center">
                {slide.primaryBtn && slide.primaryLink && (
                  <Link
                    to={slide.primaryLink}
                    className="px-8 py-3 rounded-full bg-background-soft text-primary-900 font-medium hover:bg-primary-900 hover:text-primary-50 transition"
                  >
                    {slide.primaryBtn}
                  </Link>
                )}

                {slide.secondaryBtn && slide.secondaryLink && (
                  <Link
                    to={slide.secondaryLink}
                    className="px-8 py-3 rounded-full border border-white text-white hover:bg-white hover:text-black transition"
                  >
                    {slide.secondaryBtn}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </Carousel>
  );
};

export default LandingPage;